import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BbitWebShopNotificationService } from '@bbitgmbh/webshop.sdk';
import { BbitCookieState, BbitGdprService, I18nPipe } from '@bbitgmbh/website.sdk';
import { NgIcon } from '@ng-icons/core';
import { FooterComponent } from './footer/footer.component';
import { NavComponent } from './nav/nav.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NavComponent, RouterOutlet, FooterComponent, NgIcon, AsyncPipe, I18nPipe],
})
export class AppComponent {
  public BbitCookieState = BbitCookieState;

  constructor(
    // private _algolia: BbitWebShopAlgoliaService,
    public notification: BbitWebShopNotificationService,
    // private _api: BbitWebShopApiService,
    public gdpr: BbitGdprService,
  ) {}
}
